import React from "react";
import PropTypes from "prop-types";

const ChatNotification = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "chat-notification",
    dangerouslySetInnerHTML: {
      __html: props.message
    }
  });
};

ChatNotification.propTypes = {
  message: PropTypes.string
};
export default ChatNotification;